module.exports = __webpack_public_path__ + "img/baoyu.e4e781b6.jpg";